import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import useOutsideClick from '../../hooks/useOutsideClick'

const Container = styled.div``
const SearchContainer = styled.div`
  margin-right: 20px;
  display: flex;
  font-weight: 600;

  height: 20px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  svg {
    margin-right: 5px;
    fill: #808080;
  }
`
const InputContainer = styled.div`
  margin-right: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 20px;
  margin-right: 5px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: -10px;

  position: relative;
  p {
    margin: 0px;
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 0px;
  }
  input {
    width: calc(100% - 20px);
    outline: none;
    background-color: none;
    border: none;
  }
  svg {
    /* margin-top: 5px; */
    margin-right: 5px;
    fill: #808080;
    height: 25px;
    width: 25px;
  }
  svg:last-child {
    margin-right: 5px;
    fill: #808080;
    position: absolute;
    height: 20px;
    width: 20px;
    right: -5px;
    top: 0px;
  }
`

const CustomSearchInput = ({
  handleChange,
  value,
  woValue,
  preventReset,
  manWomanFilter
}: {
  value: string
  manWomanFilter?:boolean
  woValue?:boolean
  handleChange: (value: string) => void
  preventReset?: boolean
}) => {
  const [hasFocus, setFocus] = useState(false)
  const inputRef = useRef(null)

  const handleChangeInput = (value: any) => {
    handleChange(value)
  }

  const handleClose = () => {
    // setFocus(false)
  }

  const handleCrossClick = (e: any) => {
    e.stopPropagation()
    setFocus(false)
    handleChange('')
    console.log('qqqqq handle cross clickc')
  }

  useOutsideClick([inputRef.current], handleClose)

  return (
    <Container data-animch>
      {hasFocus ? (
        <InputContainer ref={inputRef} data-search>
          <input
            placeholder={'Search ...'}
            value={value}
            onChange={({ target: { value } }) => handleChangeInput(value)}
            autoFocus
          />
          <p
            onClick={(e) => {
              handleCrossClick(e)
            }}
            data-theme-close
          >
            <CloseIcon data-hover />
          </p>
        </InputContainer>
      ) : (
        <SearchContainer
            style={{marginRight: woValue ? '0' : '20px'}}
            onClick={() => setFocus(true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <mask id="mask0_676_5391" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="1" y="1" width="18" height="18">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.125 9.0625C3.125 5.78331 5.78331 3.125 9.0625 3.125C12.3417 3.125 15 5.78331 15 9.0625C15 12.3417 12.3417 15 9.0625 15C5.78331 15 3.125 12.3417 3.125 9.0625ZM9.0625 1.875C5.09295 1.875 1.875 5.09295 1.875 9.0625C1.875 13.032 5.09295 16.25 9.0625 16.25C10.8223 16.25 12.4343 15.6176 13.6838 14.5676L17.0581 17.9419C17.3022 18.186 17.6979 18.186 17.942 17.9419C18.1861 17.6978 18.1861 17.3021 17.942 17.058L14.5677 13.6837C15.6176 12.4342 16.25 10.8222 16.25 9.0625C16.25 5.09295 13.032 1.875 9.0625 1.875Z" fill="black"/>
            </mask>
            <g mask="url(#mask0_676_5391)">
              <path d="M20 0H0V20H20V0Z" fill="#808080"/>
            </g>
          </svg>
          {!woValue && <p>{value ? value : 'Search'}</p>}
        </SearchContainer>
      )}
    </Container>
  )
}

export default CustomSearchInput
